import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxEchartsModule } from 'ngx-echarts';
import { EmptyStateComponent } from 'src/app/shared/components/common/empty-state/empty-state.component';
import { AlarmsPanelComponent } from './components/alarms-panel/alarms-panel.component';
import { AlertsPanelComponent } from './components/alerts-panel/alerts-panel.component';
import { MonitoramentoService } from './services/monitoramento.service';
import { buildBatchExecutionsChartOptions } from './utils/batch-executions-chart.util';
import { buildDurationDeltaChartOptions } from './utils/duration-delta-chart.util';

@Component({
  selector: 'app-monitoramento',
  templateUrl: './monitoramento.component.html',
  styleUrls: ['./monitoramento.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxEchartsModule, MatProgressSpinnerModule, EmptyStateComponent, AlertsPanelComponent, AlarmsPanelComponent],
})
export class MonitoramentoComponent implements OnInit {
  private readonly monitoramentoService = inject(MonitoramentoService);

  readonly section = signal<'metrics' | 'alerts'>('alerts');
  readonly alertTab = signal<'cadastro' | 'historico'>('cadastro');

  readonly isLoading = signal(true);
  readonly hasError = signal(false);
  readonly hasData = signal(false);
  readonly hasDeltaData = signal(false);
  readonly chartOptions = signal<Record<string, unknown>>({});
  readonly deltaChartOptions = signal<Record<string, unknown>>({});

  ngOnInit(): void {
    this.loadBatchExecutions();
  }

  private loadBatchExecutions(): void {
    this.isLoading.set(true);
    this.hasError.set(false);

    this.monitoramentoService.getBatchExecutions().subscribe({
      next: (response) => {
        const rows = response?.rows ?? [];
        this.hasData.set(rows.length > 0);
        this.hasDeltaData.set(rows.length > 1);
        this.chartOptions.set(rows.length > 0 ? buildBatchExecutionsChartOptions(rows) : {});
        this.deltaChartOptions.set(
          rows.length > 1 ? buildDurationDeltaChartOptions(rows) ?? {} : {}
        );
        this.isLoading.set(false);
      },
      error: () => {
        this.hasError.set(true);
        this.hasData.set(false);
        this.hasDeltaData.set(false);
        this.isLoading.set(false);
      },
    });
  }
}
